import { cloudApi } from '../api/index';
import { ONE_DAY, formatTime } from '../base/CONST';
const { getCloudOrderList } = cloudApi;
const PAY_TYPE = ['全部', '贡献点', '迷你币', '微信', '支付宝'];
const ORDER_TYPE = ['', '购买', '升级续费'];
const ORDER_STATE = ['', '未支付', '已支付'];
export default {
  data() {
    return {
      formInline: {
        date: [new Date() - ONE_DAY * 20, new Date()],
      },
      paymentType: '0',
      pagination: {
        page: 1,
        page_size: 10,
        total: 0,
      },
      orderList: [],
    };
  },
  created() {
    console.log('orderList created---');
    this.getOrderList();
  },
  watch: {
    paymentType: function () {
      this.pagination.page = 1;
      this.getOrderList();
    },
  },
  methods: {
    queryTableFn() {
      this.getOrderList();
    },
    getOrderList() {
      console.log('getOrderList---', this.formInline.date[1], ONE_DAY);
      getCloudOrderList({
        buy_type: this.paymentType,
        page: this.pagination.page,
        page_size: this.pagination.page_size,
        start_time: Math.floor(this.formInline.date[0] / 1000),
        end_time: Math.floor((+this.formInline.date[1] + ONE_DAY) / 1000 - 1),
      }).then(res => {
        if (res.code === 0) {
          this.orderList = res.data.list;
          this.pagination.total = res.data.total_count;
        }
      });
    },
    paginationChange(page) {
      this.pagination.page = page;
      this.getOrderList();
    },
  },
  filters: {
    formatTime: function (time) {
      return formatTime(time);
    },
    twoDigit: function (number) {
      return (+number).toFixed(2);
    },
    payType: function (item) {
      let { buy_type: type, state } = item;
      if (typeof type === 'undefined') {
        type = item.value;
        state = item.orgRow ? item.orgRow.state : 0;
      }
      if (parseInt(state, 10) !== 1) {
        return PAY_TYPE[type];
      }
      return '--';
    },
    orderType: function (type) {
      return ORDER_TYPE[type];
    },
    orderState: function (state) {
      return ORDER_STATE[state];
    },
  },
};
